/**
 * Número de exibição do registro de aluno.
 *
 * Orçamento e matrícula têm sequências próprias, separadas do Id da tabela — era
 * o Id que fazia o número de matrícula crescer a cada orçamento cadastrado.
 * Quando o registro já chegou a pré-matrícula ou matrícula, é o `idMatricula` que
 * o identifica; enquanto for orçamento, o `idOrcamento`. O Id da tabela fica só
 * como último recurso, para registro antigo que ainda não tenha sequencial.
 */
export function numeroDoAluno(aluno?: {
  idMatricula?: number | null;
  idOrcamento?: number | null;
  id?: number | null;
}): string {
  const numero = aluno?.idMatricula ?? aluno?.idOrcamento ?? aluno?.id;
  return numero != null ? String(numero) : "";
}
